import styled from 'styled-components';
import { Button, Typography } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { Paragraph } from '@/components/Typography';
import { LABEL_MEDIUM_REGULAR } from '@/components/Settings/DataExtraction/styles';

export const BLUE_COLOR = '#2F54EB';

export const Container = styled.div`
	.ant-dropdown-menu {
		text-align: center;
		padding: 8px;
		border-radius: 4px;
	}
`;

export const BellButton = styled(Button)`
	&.ant-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		border: 1px solid ${BLUE_COLOR};
		background: #ebeffd;
		color: ${BLUE_COLOR};
		gap: 8px;

		&:hover {
			background: #d6e0ff;
			border-color: ${BLUE_COLOR};
			color: ${BLUE_COLOR};
		}
	}
`;

export const DisabledBellButton = styled(BellButton)`
	&.ant-btn {
		background: #f0f0f0;
		border-color: #d9d9d9;
		color: rgba(0, 0, 0, 0.85);

		&:hover {
			background: #e6e6e6;
			border-color: #d9d9d9;
			color: rgba(0, 0, 0, 0.85);
		}
	}
`;

export const MenuItem = styled(Typography.Text)`
	padding: 8px;
	display: block;
	${LABEL_MEDIUM_REGULAR}
`;

export const IconWrapper = styled.span<{ $isOpen: boolean }>`
	margin-left: 5px;
	align-items: center;
	display: inline-flex;
	transition: transform 0.3s ease;
	transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
`;

export const Icon = styled(BellOutlined)`
	color: #2f54eb;
	font-size: 50px;
`;

export const ParagraphWrapper = styled(Paragraph)`
	font-size: 16px;
	text-align: center;
`;
